<template>
    <div class="guarantee-safe">
        <div class="img-wrapper">
            <img v-for="item in 15" v-bind:key="item" :src="getImgUrl(item)" alt="" />
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    created() {

    },
    methods : {
        getImgUrl (item) {
            let num = item<10?'0'+item.toString():item;
            return require('@/assets/images/normal/guaranteeSafe/guaranteeSate_'+ num +'.png');
        },
    }
};
</script>
<style lang="less">
.guarantee-safe {
    .img-wrapper {
        img {
            width: 100%;
            vertical-align: middle;
            display: inherit;
        }
    }

}
</style>
